import { axiosBase, errorHandler } from "./axios";

const listStudios = (input: any) => {
    return axiosBase
        .post("/api/v1/studio/list", input)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

const viewStudio = ({ id }) => {
    return axiosBase
        .get(`/api/v1/studio/view-studio/${id}`)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

const updateStudio = ({ id, body }) => {
    return axiosBase
        .put(`/api/v1/studio/update-studio/${id}`, body)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

const getStudioCity = () => {
    return axiosBase.get("/api/v1/common/get-studio-city")
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

const toggleStudioStatus = ({ id, action, reason }: { id: string; action: 'deactivate' | 'reactivate'; reason?: string }) => {
    return axiosBase
        .post('/api/v1/studio/status/update', { studioId: id, action, reason })
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

export const studioService = {
    listStudios,
    viewStudio,
    updateStudio,
    getStudioCity,
    toggleStudioStatus,
};
